export const addTrackingEvent = (event, category, action, label, trackingFormFields) => {

    if (!window.dataLayer) {
        console.warn('addTrackingEvent: "dataLayer" not set. Retrying in 300ms ...', {event, category, action, label, trackingFormFields})
        setTimeout(() => addTrackingEvent(event, category, action, label, trackingFormFields), 300)
        return
    }

    let dataLayerToPush = {
        'event': event,
        'eventCategory': category,
        'eventAction': action,
        'eventLabel': label
    };
    if (trackingFormFields !== undefined && trackingFormFields !== '') {
        dataLayerToPush['form_fields-values'] = JSON.parse(trackingFormFields);
    }
    dataLayer.push(dataLayerToPush);
}

/**
 * addTrackingEventGA4
 *
 * Examples for using this method:
 * data-tracking-event-generic="country_selection,language_selection"
 * data-tracking-event-generic-country-selection="{genericEventPropertiesCountry-> f:format.json()}"
 * data-tracking-event-generic-language-selection="{genericEventPropertiesLanguage-> f:format.json()}"
 *
 * data-tracking-event-generic="country_selection"
 * data-tracking-event-generic-country-selection='{"country_code":"de"}'
 * @param dataset
 */
export const addTrackingEventGA4 = (dataset) => {

    if (!window.dataLayer) {
        console.warn('addTrackingEventGA4: "dataLayer" not set. Retrying in 300ms ...', {dataset})
        setTimeout(() => addTrackingEventGA4(dataset), 300)
        return
    }

    const eventNames = dataset['trackingEventGeneric'] ?? ''
    const events = eventNames.split(',').map(value => value.trim())

    for (let eventName of events) {

        // generate pascal case from event name. If eventName is "country_selection_view" this will result in "trackingEventGenericCountrySelectionView"
        const dataName = 'trackingEventGeneric' + eventName
            .replace(/[_-]\w/g, match => match.charAt(1).toUpperCase())
            .replace(/^\w/, firstChar => firstChar.toUpperCase());

        // read props. The value should look like that: '{"country_code":"de"}'
        const props = dataset[dataName] !== '' ? JSON.parse(dataset[dataName].replace(/'/g, '"')) : null

        if (!props) {
            console.warn(`addTrackingEventGA4: Properties in (${dataName}) for ${eventName} not properly set`, dataset[dataName])
            return
        }

        dataLayer.push({
            event: 'generic',
            event_name: eventName,
            [eventName]: props
        });
    }
}
